import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {CustomRow} from '../table/columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {paymentmethodsColumns} from './columns/_columns'
import {PaymentMethod} from '../core/_models'
import {PaymentMethodsListLoading} from '../components/loading/PaymentMethodsListLoading'
import {PaymentMethodsListPagination} from '../components/pagination/PaymentMethodsListPagination'
import {KTCardBody} from '../../../../../_metronic/helpers'

const PaymentMethodsTable = () => {
  const paymentmethods = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => paymentmethods, [paymentmethods])
  const columns = useMemo(() => paymentmethodsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_paymentmethods'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<PaymentMethod>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<PaymentMethod>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <PaymentMethodsListPagination />
      {isLoading && <PaymentMethodsListLoading />}
    </KTCardBody>
  )
}

export {PaymentMethodsTable}
